import { connect } from 'react-redux'

import { createUnit } from '../../ducks/unit-admin'

import UnitCreate from '../UnitCreate'

export default connect(() => ({}), { createUnit })(UnitCreate)



// WEBPACK FOOTER //
// ./src/components/smart/UnitCreateContainer.js